import { Box, Button, Stack, Typography } from "@mui/material";

/** Title/subtitle plus the Back / Import fields / Copy mapping / Save mapping actions. */
const MappingPageHeader = ({
  fileName,
  canEdit,
  saving,
  importing,
  onBack,
  onImportFields,
  onCopyMapping,
  onSave,
}) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
    <Box>
      <Typography variant="h5">{fileName || "Field mapping"}</Typography>
      <Typography variant="body2" color="text.secondary">
        Draw a box on the page for the selected field. Rectangles are stored relative to the page,
        so they hold at any zoom.
      </Typography>
    </Box>
    <Stack direction="row" spacing={1}>
      <Button onClick={onBack}>Back</Button>
      {canEdit && (
        <Button disabled={importing} onClick={onImportFields}>
          {importing ? "Importing…" : "Import fields"}
        </Button>
      )}
      {canEdit && <Button onClick={onCopyMapping}>Copy mapping</Button>}
      {canEdit && (
        <Button variant="contained" disabled={saving} onClick={onSave}>
          Save mapping
        </Button>
      )}
    </Stack>
  </Stack>
);

export default MappingPageHeader;
